import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { Atol, Disclaimers, HiddenFees, Installments } from "./banners";
import {
  type UnifiedPriceBreakdownCheckoutControllerProps,
  useUnifiedPriceBreakdownCheckoutController
} from "./useUnifiedPriceBreakdown.Checkout.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownCheckoutProps = UnifiedPriceBreakdownCheckoutControllerProps;

export function UnifiedPriceBreakdownCheckout(props: UnifiedPriceBreakdownCheckoutProps) {
  const {
    addedItems,
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    unifiedPriceBreakdown,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownCheckoutController(props);
  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "Checkout", routeName });
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        addedItems={addedItems}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <HiddenFees />
      <Installments />
    </Stack>
  );
}
